/* ============
 * Add multiple products modal
 * ============
 *
 * This is the component for creating batch log
 */
import { mapGetters, mapMutations } from 'vuex';
import organizationSettingsService from './../../services/organizationSettings';
import orderProductService from './../../services/orderProduct';
import shippingService from './../../services/shippingProvider';
import warehouseService from './../../services/warehouse';
import shippingTransformer from './../../transformers/shippingConfirm';
import billService from './../../services/bill';
import orderService from './../../services/order';
import ediOrderService from './../../services/ediOrder';
import Forms from './../../utils/forms/forms';
import { sortBatchOptions, defaultBatchId } from './../../utils/batchOptions';
import QuickProductEditExcise from './../../components/quickProductEditExcise/quickProductEditExcise.vue';
import moment from 'moment';
import batchService from './../../services/batch';
import store from './../../store';

export default {
  data() {
    return {
      warehouseList: [],
      batcheList: [],
      form: new Forms({
        confirmDate: {
          value: '',
          type: 'date',
        },
        deliveryDate: {
          value: '',
          type: 'date',
        },
        warehouseId: {
          type: 'select',
          value: '',
        },
        shippingProviderId: {
          value: '',
          type: 'select',
        },
        shippingDate: {
          value: '',
          type: 'date',
        },
      }),
      loading: false,
      submitLoading: false,
      submitted: false,
      errors: [],
      options: [{
        value: 'Option1',
        label: 'Option1',
      }, {
        value: 'Option2',
        label: 'Option2',
      }, {
        value: 'Option3',
        label: 'Option3',
      }, {
        value: 'Option4',
        label: 'Option4',
      }, {
        value: 'Option5',
        label: 'Option5',
      }],
      value1: [],
      selectedBatchProduct: [],
    };
  },
  props: {
    operation: {
      type: String,
      required: true,
      default: '',
    },
    selectedOrders: {
      type: Array,
      required: true,
      default: () => [],
    },
    onSubmit: {
      type: Function,
      required: true,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      orderProducts: 'allOrderProducts',
      warehouses: 'allWarehouses',
      settings: 'organizationSettings',
      account: 'account',
      shippingProviders: 'allShippingProviders',
      batches: 'allBatches',
    }),
    successStatus() {
      const statuses = {
        confirmOrder: 'Confirmed',
        confirmShipping: 'Confirmed Shipping',
        confirmOrderAndShipping: 'Confirmed Order & Shipping',
        createInvoice: 'Invoiced',
        cancelOrder: 'Cancelled',
      };

      return statuses[this.operation];
    },

    showForm() {
      return !['cancelOrder', 'createInvoice'].includes(this.operation);
    },
    orders() {
      return this.selectedOrders;
    },

    nonEdiOrders() {
      return this.selectedOrders.filter(item => !item.isEdi);
    },

    ediOrders() {
      return this.selectedOrders.filter(item => item.isEdi);
    },

    errorsByOrder() {
      return this.errors.length ? this.errors.reduce((errors, item) => {
        const order = (errors[item.order_id] || []);
        order.push(item);
        errors[item.order_id] = order;
        return errors;
      }, {}) : [];
    },

    selectedOrderIds() {
      return this.selectedOrders.map(item => item.id);
    },
    selectedNonEdiOrderIds() {
      return this.nonEdiOrders.map(item => item.id);
    },
    selectedEdiOrderIds() {
      return this.ediOrders.map(item => item.ediOrderId);
    },

    batchProducts() {
      return this.batcheList;
    },

    bevearageProducts() {
      return this.orderProducts.filter(p => p.productType === 'Beverage' || p.productTypeGroup === 'Beverage').map((item) => {
        const excise = [];
        if (item.exciseAlcoholGroup) {
          excise.push(item.exciseAlcoholGroupName);
        }
        if (item.excisePackagingGroup) {
          excise.push(item.excisePackagingGroupName);
        }
        if (item.exciseBasicGroup) {
          excise.push(item.exciseBasicGroupName);
        }

        return {
          id: item.id,
          name: item.name,
          beverage: item.exciseAlcoholGroupName || '-',
          packaging: item.excisePackagingGroupName || '-',
          basic: item.exciseBasicGroupName || '-',
          excisable: item.excisable,
          bottleVolume: item.fieldsJSON.bottle_volume,
          alcoholPercentage: item.fieldsJSON.alcohol_percentage,
          noExcise: !item.excisable || excise.length === 0 || !item.fieldsJSON.bottle_volume || !item.fieldsJSON.alcohol_percentage,
        };
      });
    },
    hasNoExcise() {
      return this.bevearageProducts.filter(p => p.noExcise).length !== 0 && this.hasExciseModule;
    },
    hasExciseModule() {
      let hasExciseModule = false;
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Excise') {
            hasExciseModule = true;
          }
        }
      }
      return hasExciseModule;
    },
  },

  mounted() {
    this.configureFieldVisibility();
    this.form.confirmDate = moment().format('YYYY-MM-DD');
    this.loading = true;
    Promise.all([
      warehouseService.all(),
      organizationSettingsService.show(),
      shippingService.all(),
      orderProductService.allBulk(this.selectedOrderIds),
      batchService.all({
        has_warehouse_transaction: 1,
        for_select: 1,
      }),
    ]).then(() => {
      this.loading = false;
      this.warehouseList = this.warehouses.items.filter(obj => obj.isActive === true);
      this.form.warehouseId = this.settings.defaultWarehouse;
      this.form.shippingProviderId = +this.settings.defaultShippingProvider;
      this.selectedBatchProduct = this.batchProducts.map(c => ({ batchIds: c.selectedBatch, productId: c.productId, id: c.id, orderId: c.orderId }));
    });
  },
  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
    }),

    updateBatchProduct(value) {
      this.selectedBatchProduct = this.selectedBatchProduct.filter(obj => obj.productId !== value.productId);
      this.selectedBatchProduct.push([value].map(c => ({ batchIds: c.selectedBatch, productId: c.productId, id: c.id, orderId: c.orderId }))[0]);
    },

    getOrder(id) {
      return this.selectedOrders.find(o => o.id === +id);
    },

    configureFieldVisibility() {
      if (!this.ediOrders.length) {
        this.form.hideField('deliveryDate');
      }
      if (this.operation === 'confirmOrder') {
        this.form.hideField('shippingProviderId');
        this.form.hideField('shippingDate');
      }
      if (this.operation === 'confirmShipping') {
        this.form.hideField('confirmDate');
        this.form.hideField('warehouseId');
        this.form.hideField('deliveryDate');
      }
    },

    handleSubmit() {
      this.submitLoading = true;
      this.onSubmit(this.selected).then(() => {
        this.submitLoading = false;
        this.closeModal();
      }).catch((errors) => {
        if (errors.items) {
          this.$message({
            showClose: true,
            message: this.$t('static.bulkProductAdd.emptySelectionError'),
            type: 'error',
          });
        }
        this.submitLoading = false;
      });
    },

    transform(data) {
      return {
        confirmDate: data.confirm_date,
        deliveryDate: data.delivery_date,
        warehouseId: data.warehouse_id,
        shippingProviderId: data.shipping_provider_id,
        shippingDate: data.shipping_date,
      };
    },
    confirm() {
      this.$confirm(`${this.$t('static.ediOrders.index.confirmAction1')} ${this.$t(`static.ediOrders.index.action.${this.operation}`)} ${this.$t('static.ediOrders.index.confirmAction2')} ${this.selectedOrders.length} ${this.$t('static.ediOrders.index.confirmAction3')}`, this.$t('static.ediOrders.index.confirmActionTitle'), {
        confirmButtonText: this.$t('button.yes'),
        cancelButtonText: this.$t('button.no'),
        type: 'warning',
      }).then(() => {
        if (this.operation === 'confirmOrder') {
          this.confirmOrder();
        } else if (this.operation === 'confirmShipping') {
          this.confirmShipping();
        } else if (this.operation === 'confirmOrderAndShipping') {
          this.confirmOrderAndShipping();
        }
      }).catch(() => {});
    },
    confirmOrder() {
      this.submitLoading = true;
      const client = shippingTransformer.send(
        Object.assign({}, this.form.data())
      );

      const resources = [];
      if (this.nonEdiOrders.length) {
        resources.push(
          orderService.bulkConfirm(this.selectedNonEdiOrderIds, client)
        );
      }
      if (this.ediOrders.length) {
        resources.push(
          ediOrderService.bulkConfirm(this.selectedEdiOrderIds, client)
        );
      }

      return Promise.all(resources)
        .then((data) => {
          this.showResult(data);
        })
        .catch((errors) => {
          this.submitLoading = false;
          this.form.recordErrors(this.transform(errors.data));
          const message = errors.data.message;
          if (message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },

    confirmShipping() {
      this.submitLoading = true;
      const formData = shippingTransformer.send(
        Object.assign({}, this.form.data())
      );
      const resources = [];
      if (this.nonEdiOrders.length) {
        resources.push(
          orderService.bulkConfirmShipping(this.selectedNonEdiOrderIds, formData)
        );
      }
      if (this.ediOrders.length) {
        resources.push(
          ediOrderService.bulkProcess(this.selectedEdiOrderIds, formData)
        );
      }

      return Promise.all(resources)
        .then((data) => {
          this.showResult(data);
        })
        .catch((errors) => {
          this.submitLoading = false;
          this.form.recordErrors(this.transform(errors.data));
          const message = this.$t('static.ediOrders.edit.confirmError');
          if (message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },

    confirmOrderAndShipping() {
      this.submitLoading = true;
      const formData = shippingTransformer.send(
        Object.assign({}, this.form.data())
      );

      // Update bulk batch first before confirming
      this.selectedBatchProduct.forEach((item) => {
        orderProductService.update(item.orderId, item, item.id, 'bulk');
      });

      const resources = [];
      if (this.nonEdiOrders.length) {
        resources.push(
          orderService.bulkConfirmAndShipping(this.selectedNonEdiOrderIds, formData)
          );
      }
      if (this.ediOrders.length) {
        resources.push(
          ediOrderService.bulkConfirmAndShipping(this.selectedEdiOrderIds, formData)
          );
      }

      return Promise.all(resources)
      .then((data) => {
        this.showResult(data);
      })
        .catch((errors) => {
          this.submitLoading = false;
          this.form.recordErrors(this.transform(errors.data));
          const message = this.$t('static.ediOrders.edit.confirmError');
          if (message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },

    cancelOrder() {
      Promise.all([orderService.bulkCancel(this.selectedOrderIds)])
        .then((data) => {
          this.showResult(data);
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: this.$t('static.orders.edit.cancelError'),
            type: 'error',
          });
        });
    },

    createInvoices() {
      this.submitLoading = true;
      Promise.all([billService.store({ order_ids: this.selectedOrderIds })])
        .then((data) => {
          this.showResult(data);
        })
        .catch((errors) => {
          if (errors.code === 40116) {
            errors = {
              orderId: [this.$t('static.bills.create.orderError')],
            };
          }

          this.form.recordErrors(errors);
        });
    },

    showResult(data) {
      this.submitted = true;
      this.submitLoading = false;

      let errors = [];
      data.forEach((item) => {
        errors = [].concat(errors, item.errors);
      });
      if (errors.length) {
        this.errors = errors;
      }
    },

    quickProductEdit(id) {
      const item = this.orderProducts.find(p => +p.id === +id);
      if (item) {
        this.setModalProps({
          productId: item.productId,
          productName: item.name,
          orderProduct: item,
          isEdi: false,
          destination: () => require('./../../components/bulkProcessOrderModal/bulkProcessOrderModal.vue'),
          destinationProps: {
            operation: this.operation,
            selectedOrders: this.selectedOrders,
            onSubmit: () => this.onSubmit,
          },
        });
        this.toggle(true);
        this.setModalContent(() => QuickProductEditExcise);
      }
    },
    /*
     * Closes the modal
     */
    closeModal() {
      if (this.submitted) {
        this.onSubmit();
      }
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  watch: {
    warehouseList(warehouses) {
      let hasModule = false;
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Inventory') {
            hasModule = true;
            this.form.setOptions('warehouseId', warehouses);
          }
        }
      }

      /* if (!hasModule) {
        this.form.hideField('warehouseId');
      } else if (this.currentOrder.warehouseId == 0) {
        this.form.showField('warehouseId');
      } else {
        this.form.hideField('warehouseId');
      } */
    },

    'form.warehouseId': function (value) {
      const orderProducts = [...new Map(this.orderProducts.map(v => [v.productId, v])).values()];
      this.batcheList = orderProducts.filter(p => p.productType === 'Beverage' || p.productTypeGroup === 'Beverage').map((item) => {
        const products = item.warehouses;

        let options = [];
        if (products.length) {
          const batchIds = products.map(p => p.batchId.toString());
          const nonBatchProduct = products.find(p => p.batchId === 0 &&  parseInt(value) === parseInt(p.warehouseId));
          options = nonBatchProduct ? [{
            id: '0',
            name: `${this.$t('static.orders.edit.nonBatch')} | ${this.$t('static.orders.edit.availableQty')}: ${nonBatchProduct.qtyNumber}`,
            available: nonBatchProduct.qtyNumber,
          }] : [];

          options = options.concat(this.batches.filter(b => (batchIds.indexOf(b.id) !== -1)).map((batch) => {
            const batchProduct = products.find(p => (p.batchId.toString() === batch.id.toString() && parseInt(value) === parseInt(p.warehouseId)));
            if (batchProduct) {
              return Object.assign({}, {
                id: batch.id.toString(),
                name: `${batch.code} | ${this.$t('static.orders.edit.availableQty')}: ${batchProduct.qtyNumber}`,
                available: batchProduct.qtyNumber,
              });
            }
            return [];
          }));
        }

        // Batches not stocked in this warehouse map to [] above; sortBatchOptions drops those.
        options = sortBatchOptions(options, { hideEmpty: true });
        const selectedBatch = options.length > 0 ? [defaultBatchId(options)] : [];
        options = options.map(c => ({ value: c.id, label: c.name }));
        return {
          id: item.id,
          name: item.name,
          batchOptions: options,
          selectedBatch,
          productId: item.productId,
          orderId: item.orderId,
        };
      });
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} shipping providers    The shipping providers list.
     */
    shippingProviders(shippingProviders) {
      let hasModule = false;
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Shipping Provider') {
            hasModule = true;
          }
        }
      }
      if (hasModule) {
        this.form.setOptions('shippingProviderId', shippingProviders.map(c => ({ id: c.id, name: `${c.name} ` })));
      } else {
        this.form.hideField('shippingProviderId');
      }
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/bulkProcessOrderModal/bulkProcessOrderModal.js